import React from "react"
import _ from "lodash"
import "../../assets/css/pages/track_progress/work-product-row.css"
import WorkProductQualityProgressBar from "../../components/WorkProductQualityProgressBar"
import ArgumentBuilderSubmissions from "./ArgumentBuilderSubmissions"
import ResearchSubmissions from "./ResearchSubmissions"
import FlowchartSubmissions from "./FlowchartSubmissions"
import HeredityProbabilitySubmissions from "./HeredityProbabilitySubmissions"
import CategorizationSubmissions from "./CategorizationSubmissions"
import FrequencyChartSubmissions from "./FrequencyChartSubmissions"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
library.add(faPlus, faMinus)

class WorkProductRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isExpanded: false }
  }

  handleToggleExpansion = () => this.setState({ isExpanded: !this.state.isExpanded })

  submissionsComponent = type => {
    const { submissionData } = this.props
    switch (type) {
      case "Argument Builder":
        return <ArgumentBuilderSubmissions {...submissionData} />
      case "Research":
        return <ResearchSubmissions {...submissionData} />
      case "Flowchart":
        return <FlowchartSubmissions {...submissionData} />
      case "Heredity Probability":
        return <HeredityProbabilitySubmissions {...submissionData} />
      case "Categorization":
        return <CategorizationSubmissions {...submissionData} />
      case "Frequency Chart":
        return <FrequencyChartSubmissions {...submissionData} />
    }
  }

  generateType = type => {
    const { submissionData } = this.props
    if (type === "Frequency Chart") {
      switch (submissionData.taskMode) {
        case "dot-plot":
          return "Make Dot Plot from given Table"
        case "histogram":
          return "Make Histogram from given Table"
        case "tally":
          return "Make Tally Chart from given Table"
        case "histo-tally":
          return "Make Histogram from given Tally Chart"
        default:
          return ""
      }
    }
    return type
  }

  render() {
    const { type, percentages, submissionData } = this.props
    return (
      <div className='work-product-row'>
        <div className='row-header'>
          <h2>{this.generateType(type)}</h2>
          <WorkProductQualityProgressBar {...percentages} />
          {!_.isEmpty(submissionData) && (
            <span onClick={this.handleToggleExpansion} className='expansion-button'>
              <FontAwesomeIcon icon={this.state.isExpanded ? "minus" : "plus"} />
            </span>
          )}
        </div>
        <div className='expansion-contents'>
          {this.state.isExpanded && this.submissionsComponent(type)}
        </div>
      </div>
    )
  }
}

export default WorkProductRow
